/**
 * Configuration consumed by the standalone Ariva header bundle.
 *
 * The bundle reads `window.appConfig` once, at `init()` time. These values
 * point at the Ariva backend (separate from this app's own API), and can be
 * overridden per-environment via `VITE_APP_ARIVA_HEADER_*` env vars. The
 * fallbacks below are the catalog/staging endpoints shipped with the bundle.
 */
export type ArivaHeaderAppConfig = {
  apiBaseUrl: string;
  legacyApiPublicBaseUrl: string;
  quoteFeedUrl: string;
  legacyWebBaseUrl: string;
};

const env = import.meta.env;

export const arivaHeaderAppConfig: ArivaHeaderAppConfig = {
  apiBaseUrl:
    env.VITE_APP_ARIVA_HEADER_API_BASE_URL ??
    "https://ariva-portal-web-cat.ariva-services.de/apiv3/",
  legacyApiPublicBaseUrl:
    env.VITE_APP_ARIVA_HEADER_LEGACY_API_BASE_URL ??
    "https://ariva-portal-web-cat.ariva-services.de/api/",
  quoteFeedUrl:
    env.VITE_APP_ARIVA_HEADER_QUOTE_FEED_URL ??
    "https://signalr.wallstreet-online.de/koojoo",
  legacyWebBaseUrl:
    env.VITE_APP_ARIVA_HEADER_LEGACY_WEB_BASE_URL ??
    "https://ariva-portal-web-cat.ariva-services.de/",
};

/**
 * URL where the bundle assets are served. Includes the app's base path
 * (`import.meta.env.BASE_URL`, e.g. `/v2/`) so the absolute requests resolve
 * correctly when the app is deployed under a sub-path.
 */
export const ARIVA_HEADER_ASSET_BASE = `${import.meta.env.BASE_URL}ariva-header`;

/** Class on the container the header markup is injected into; also the CSS scope root. */
export const ARIVA_HEADER_ROOT_CLASS = "ariva-header-root";

/**
 * Rendered height of the standalone Ariva header (`h-[85px] sm:h-[140px]` in
 * the bundle markup). Used to offset fixed/full-height layout elements (e.g.
 * the sidebar) so they sit below the header instead of underneath it.
 */
export const ARIVA_HEADER_HEIGHT_MOBILE = 85;
export const ARIVA_HEADER_HEIGHT_DESKTOP = 140;

/**
 * Scroll distance (px) from the top at which the header hides. Above this the
 * header is shown; past it the header hides (position-based, not direction).
 * Shared by the header and the sidebar so they extend/collapse in sync.
 */
export const ARIVA_HEADER_HIDE_SCROLL_THRESHOLD = 140;
